import React from 'react';
import { FiShoppingBag } from 'react-icons/fi';
import { MdOutlineAdminPanelSettings, MdOutlineDiscount } from 'react-icons/md';
import { orderingType } from '../../state/shop/cyodSlice';
import CurrencyFormatter from '../../utils/text/CurrencyFormatter';
import Typography from '../typography/Typography';

interface options {
  id: orderingType;
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  value?: number;
  valueRequired?: boolean;
  valueDescription?: string;
  handleOnclick?: (type: orderingType) => void;
}

interface props {
  handleOnclick?: (type: orderingType) => void;
  coupon?: number;
}

const OrderingTypeModal = ({ handleOnclick, coupon }: props) => {
  const options: options[] = [
    {
      id: 'standard',
      title: 'Regular shop',
      subtitle: 'Ik wil eens rondkijken en eventueel iets kopen',
      icon: <FiShoppingBag />,
    },
    {
      id: 'cyod',
      title: 'CYOD',
      subtitle: 'Gebruik je coupon om een selectie producten te kiezen',
      value: coupon,
      valueRequired: true,
      valueDescription: 'Coupon: ',
      icon: <MdOutlineDiscount />,
    },
    {
      id: 'administrator',
      title: 'Administrator',
      subtitle: 'Bestel in naam van je bedrijf',
      icon: <MdOutlineAdminPanelSettings />,
    },
  ];

  return (
    <div className="w-full max-w-3xl rounded-xl bg-white p-6 shadow-xl">
      <h2 className="mb-6 text-xl font-semibold text-center">
        Choose ordering type
      </h2>

      <div className="grid grid-cols-3 gap-4">
        {options.map((option) => (
          <button
            key={option.id}
            onClick={() => handleOnclick && handleOnclick(option.id)}
            {...(option.valueRequired && option.value === 0
              ? { disabled: true }
              : {})}
            className="
              aspect-square
              rounded-xl
              border
              p-4
              flex
              flex-col
              items-center
              justify-center
              text-center
              hover:bg-gray-50
              hover:border-gray-300
              transition
            "
          >
            <div className="mb-3 text-3xl">{option.icon}</div>

            <div className="font-medium">{option.title}</div>
            <div className="text-sm text-gray-500">{option.subtitle}</div>
            {option.value !== undefined && option.value > 0 && (
              <div className="mt-2 text-sm font-semibold text-green-600">
                <Typography tag="span" type="label">
                  {option.valueDescription}
                </Typography>{' '}
                <CurrencyFormatter price={option.value} />
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default OrderingTypeModal;
